// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__DVu8X","password":"PasswordResetForm_password__2fKQA"};